import * as Y from 'yjs';
import { WebsocketProvider } from 'y-websocket';
import type { RoomClaim } from '../api.ts';

export interface BoardSession {
  doc: Y.Doc;
  provider: WebsocketProvider;
  destroy(): void;
}

export function connectBoard(claim: RoomClaim, onStatus?: (status: string) => void): BoardSession {
  const doc = new Y.Doc();
  const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
  const provider = new WebsocketProvider(`${protocol}//${location.host}/yjs`, claim.roomId, doc, {
    params: { token: claim.token },
    connect: true,
    disableBc: true,
  });
  provider.on('status', ({ status }: { status: string }) => onStatus?.(status));
  return {
    doc,
    provider,
    destroy: () => {
      provider.destroy();
      doc.destroy();
    },
  };
}
